import {Injectable} from '@angular/core';
import {Loading, LoadingController} from 'ionic-angular';

@Injectable()
export class LoadingService {
  loading: Loading;
  loaderStatus: any;
  public loadingText: any = 'Loading';

  constructor(private loadingCtrl: LoadingController) {

    this.loading = this.loadingCtrl.create({
      content: this.loadingText
    });

    this.loading.onDidDismiss(() => {
      this.loaderStatus = false;
      console.log('Dismissed loading');
    });
  }

  public hideLoader() {
    if (this.loaderStatus && this.loading != null) {
      this.loading.dismissAll();
      this.loading = null;
      this.loaderStatus = false;
    }
  }

  public showLoader(content: string, cssClass?: string) {
    this.hideLoader();
    let config = {
      content: content,
      cssClass: cssClass
    };
    this.loading = this.loadingCtrl.create(config);
    this.loading.present();
    this.loaderStatus = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/util/loading.service.ts